// v3.7.6: Full implementation — migrated from ChatSidebar.tsx
import React from 'react';
import { motion } from 'motion/react';
import { Search, Plus, Loader2, X, Home, Square, ChevronLeft } from 'lucide-react';

interface SidebarHeaderProps {
  collapsed: boolean; setCollapsed: (v: boolean) => void;
  searchQuery: string; setSearchQuery: (q: string) => void; searching: boolean;
  onNewChat: () => void; onReturnToDesktop: (() => void) | undefined;
  lang: 'en' | 'zh'; isZh: boolean;
  selectionMode: boolean; setSelectionMode: (v: boolean) => void;
  setSelectedIds: (v: Set<string>) => void;
}

export const SidebarHeader = React.memo(function SidebarHeader(props: SidebarHeaderProps) {
  const { collapsed, setCollapsed, searchQuery, setSearchQuery, searching, onNewChat, onReturnToDesktop, isZh, selectionMode, setSelectionMode, setSelectedIds } = props;
  return (
    <div className="p-4 pb-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] font-bold uppercase tracking-widest text-white/55">
          {isZh ? '小枫工作台' : 'Workbench'}
        </span>
        <div className="flex items-center gap-1">
          <button
            onClick={() => onReturnToDesktop?.()}
            title={isZh ? '返回桌面' : 'Return to Desktop'}
            className="p-1 rounded-lg text-white/55 hover:text-white/60 hover:bg-white/[0.06] transition-all"
          >
            <Home size={15} />
          </button>
          <button
            onClick={() => { setSelectionMode(!selectionMode); setSelectedIds(new Set()); }}
            title={isZh ? '批量管理' : 'Batch'}
            className={`p-1 rounded-lg transition-all ${selectionMode ? 'text-celestial-saturn bg-white/[0.06]' : 'text-white/55 hover:text-white/60 hover:bg-white/[0.06]'}`}
          >
            <Square size={14} />
          </button>
          <button
            onClick={() => setCollapsed(true)}
            title={isZh ? '收起侧边栏' : 'Collapse'}
            className="p-1 rounded-lg text-white/55 hover:text-white/60 hover:bg-white/[0.06] transition-all"
          >
            <ChevronLeft size={15} />
          </button>
        </div>
      </div>
      <div className="relative mb-2">
        <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
        <input
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={isZh ? '搜索对话内容…' : 'Search chats…'}
          className="w-full bg-white/[0.06] border border-white/10 rounded-xl pl-8 pr-7 py-2 text-xs text-white/80 placeholder:text-white/55 outline-none focus:border-celestial-saturn/40 transition-colors"
        />
        {searching && (
          <Loader2 size={12} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/30 animate-spin" />
        )}
        {searchQuery && !searching && (
          <button onClick={() => setSearchQuery('')} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-white/30 hover:text-white/60">
            <X size={12} />
          </button>
        )}
      </div>
      <motion.button
        whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
        onClick={onNewChat}
        className="w-full flex items-center justify-center gap-2 py-3 rounded-2xl bg-gradient-to-r from-celestial-saturn/20 to-celestial-saturn/10 border border-celestial-saturn/30 text-celestial-saturn text-sm font-bold hover:border-celestial-saturn/50 hover:bg-celestial-saturn/25 shadow-[0_0_20px_rgba(255,204,0,0.08)] transition-all duration-300"
      >
        <Plus size={16} />
        <span>{isZh ? '新建对话' : 'New Chat'}</span>
      </motion.button>
    </div>
  );
});
